export interface product {
   srcImage: string;
   title: string;
   text: string;
   link: string;
}

export const ProductsList: product[] = [
   {
      srcImage: '/image-products/programator.webp',
      title: 'Программатор-отладчик TU-Link_V2.1_BQ25895 для STM32',
      text: 'Внутрисхемный программатор-отладчик для микроконтроллеров семейства STM32. В устройство встроен порт Type-C, который имеет ряд преимуществ перед другими разъёмами.',
      link: '/products/1'
   }
]

